// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    agentId: z.string().min(1).max(21),
    address: z.string().min(1).max(256),
    destinationEmail: z.string().min(1).max(90),
    destinationId: z.string().max(32).nullable().optional(),
    providerRuleId: z.string().max(32).nullable().optional(),
    provider: z.string().min(1).max(32).optional(),
    status: z.string().min(1).max(32),
    lastError: z.string().max(256).nullable().optional(),
    createdAt: z.number().optional(),
    updatedAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    agentId: z.string().min(1).max(21),
    address: z.string().min(1).max(256),
    destinationEmail: z.string().min(1).max(90),
    destinationId: z.string().max(32).nullable(),
    providerRuleId: z.string().max(32).nullable(),
    provider: z.string().max(32),
    status: z.string().min(1).max(32),
    lastError: z.string().max(256).nullable(),
    createdAt: z.number(),
    updatedAt: z.number(),
});
export const AgentEmailRoutes = Object.freeze({
    table: 'agent_email_routes',
    tableSingular: 'agent_email_route',
    fields: {
        tenantId: 'tenant_id',
        agentId: 'agent_id',
        address: 'address',
        destinationEmail: 'destination_email',
        destinationId: 'destination_id',
        providerRuleId: 'provider_rule_id',
        provider: 'provider',
        status: 'status',
        lastError: 'last_error',
        createdAt: 'created_at',
        updatedAt: 'updated_at',
    },
    fieldKeys: [
        'tenantId',
        'agentId',
        'address',
        'destinationEmail',
        'destinationId',
        'providerRuleId',
        'provider',
        'status',
        'lastError',
        'createdAt',
        'updatedAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
